import axios from "axios";

const getBaseURL = () => {
  return process.env.REACT_APP_API_URL || (typeof import.meta !== "undefined" && import.meta.env?.VITE_API_URL) || "https://jobtracking.thesalonx.in/api";
};

const API = axios.create({
  baseURL: getBaseURL(),
});

// ✅ Attach token + Accept header
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  config.headers["Accept"] = "application/json";

  return config;
});

// ✅ Handle token expiry
API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const isLogin = error.config && error.config.url && error.config.url.includes("/login");
      if (!isLogin) {
        localStorage.removeItem("token");
        window.dispatchEvent(new Event("logout"));
      }
    }
    return Promise.reject(error);
  }
);

export default API;